/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportCommentFormContainer_comment = {
    readonly id: string;
    readonly revision: {
        readonly id: string;
    } | null;
    readonly story: {
        readonly url: string;
    };
    readonly " $refType": "ReportCommentFormContainer_comment";
};
export type ReportCommentFormContainer_comment$data = ReportCommentFormContainer_comment;
export type ReportCommentFormContainer_comment$key = {
    readonly " $data"?: ReportCommentFormContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ReportCommentFormContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentRevision",
                "kind": "LinkedField",
                "name": "revision",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Story",
                "kind": "LinkedField",
                "name": "story",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '004a19901c78963897cae4102b4a1804';
export default node;
